import { render, staticRenderFns } from "./BookvisitInformationDialog.vue?vue&type=template&id=5ba7311e&scoped=true"
import script from "./BookvisitInformationDialog.vue?vue&type=script&lang=js"
export * from "./BookvisitInformationDialog.vue?vue&type=script&lang=js"
import style0 from "./BookvisitInformationDialog.vue?vue&type=style&index=0&id=5ba7311e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba7311e",
  null
  
)

export default component.exports